
import L from 'leaflet';

interface MapProjectionTypes {
    EPSG4326: string;
    EPSG25833: string;
    EPSG32633: string;
}

interface MapConfig {
    projections: MapProjectionTypes;
    PADBOUNDS_FACTOR: number;
    LOCALIZATION_OK_THRESHOLD: number
    STYLES: { [key: string]: L.PathOptions };
}

export const dataforvalterMapConfig: MapConfig  = {

    projections: {
        EPSG25833:  '+proj=utm +zone=33 +ellps=ETS80 +units=m +no_defs',
        EPSG32633:  '+proj=utm +zone=33 +ellps=WGS84 +datum=WGS84 +units=m +no_defs',
        EPSG4326:   'EPSG:4326'
    },

    PADBOUNDS_FACTOR: 0.05, //getBounds() kan returnere bounds med feature helt i kantene. Utvider litt for å få dem til å vises.
    LOCALIZATION_OK_THRESHOLD: 0.8,

    STYLES: {
        defaultStyle: {
            color: '#337ACE',
            opacity: 0.8
        },
        existingObjectsStyle: {
            color: '#ff7800'
        },
        highlightStyle: {
            color: '#ef6353',
            fillOpacity: 0.8,
            opacity: 1
        },
        highlightStyle4: {
            color: '#ff00f2',
            fillOpacity: 0.8,
            opacity: 1
        },
    }
};
